import React from "react";
import { LangContextProps } from "../types/context.type";

export const LangContext = React.createContext<LangContextProps>({});
